import React, { useEffect, useState } from 'react';
import { 
  Typography,
  Box
} from '@mui/material';
import QRCode from 'qrcode';

import MoovsDialog from 'components/MoovsDialog';
import { QRCodeViewModalProps } from '../types';
import { useAnalytics } from 'globals/hooks';

function QRCodeViewModal(props: QRCodeViewModalProps) {
  const { open, onClose, qrCode, onDownload } = props;

  // hooks
  const { track } = useAnalytics();

  // state
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>('');

  // event handlers
  useEffect(() => {
    if (open && qrCode) {
      setQrCodeDataUrl('');
      QRCode.toDataURL(qrCode.fullUrl, { 
        width: 250,
        margin: 1,
        color: { dark: '#000', light: '#fff' }
      })
        .then((dataUrl) => {
          setQrCodeDataUrl(dataUrl);
          track('qrCodeApp_viewed_qrCode');
        })
        .catch((err) => {
          console.error("Error generating QR code:", err);
        });
    }
  }, [open, qrCode, track]);

  return (
    <MoovsDialog
      open={open}
      onClose={onClose}
      acceptButtonText="Download"
      onAccept={onDownload}
      dialogTitle={qrCode.displayName}
      size="sm"
    >
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          py: 2,
          px: 1,
          overflow: 'hidden',
          maxHeight: '60vh'
        }}
      >
        {qrCodeDataUrl ? (
          <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              width: '100%',
              maxWidth: '250px',
              maxHeight: '250px',
              overflow: 'hidden'
            }}
          >
            <img 
              src={qrCodeDataUrl} 
              alt={qrCode.displayName} 
              style={{ 
                maxWidth: '100%', 
                maxHeight: '100%', 
                objectFit: 'contain' 
              }} 
            />
          </Box>
        ) : (
          <Typography>Generating QR code...</Typography>
        )}
        
        <Typography 
          variant="subtitle1" 
          sx={{ 
            mt: 2, 
            textAlign: 'center',
            wordBreak: 'break-all',
            overflowWrap: 'break-word',
            overflow: 'wrap',
            whiteSpace: 'normal',
            width: '100%',
            px: 1
          }}
        >
          {qrCode.fullUrl}
        </Typography>
      </Box>
    </MoovsDialog>
  );
};

export default QRCodeViewModal;